/* eslint-disable unicorn/filename-case */

import { VehicleExtraImagePositions, VehicleImagePositions } from "@repo/types";
import type { DamagedCarImages, ImageValue, Vehicle } from "@/types/models/vehicle.types";

import { findKeyValue, getS3Url } from "@/utils/getData";

export type ImageSource = { key?: string; url: string };

function resolveImageSource(value: unknown): ImageSource | undefined {
  if (!value) return undefined;
  if (typeof value === "string") return { url: value };
  if (typeof value === "object" && value !== null) {
    const v = value as ImageValue;
    if (typeof v.url === "string" && v.url !== "") return { key: v.key, url: v.url };
  }
  return undefined;
}

export function getImageSource(
  images: DamagedCarImages | undefined,
  key: string
): ImageSource | undefined {
  if (!images) return undefined;

  const value = findKeyValue(images, key);
  const image = resolveImageSource(value);
  if (!image) return undefined;

  const url = image.url.includes("http") ? image.url : getS3Url(image.url);
  return url ? { ...image, url } : undefined;
}

export function getImageUrl(images: DamagedCarImages | undefined, key: string): string | undefined {
  return getImageSource(images, key)?.url;
}

export function getImageSources(images: DamagedCarImages | undefined): ImageSource[] {
  return [...VehicleImagePositions, ...VehicleExtraImagePositions].flatMap((key) => {
    const image = getImageSource(images, key);
    return image ? [image] : [];
  });
}

export function getBeforeAfterImages(
  vehicle: Pick<Vehicle, "imagesBefore" | "imagesAfter">,
  selectedKey: string
) {
  const beforeImage = getImageSource(vehicle.imagesBefore, selectedKey);
  const afterImage = getImageSource(vehicle.imagesAfter, selectedKey);
  return {
    beforeImage,
    afterImage,
  };
}
